



import { Vue, Component } from 'vue-property-decorator'

import MainCon from './components/MainCon/index.vue'
@Component({
  components: {
    MainCon,
  },
})
export default class extends Vue {}
